module.exports = __webpack_public_path__ + "img/stepArrow.c91d061e.svg";